var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import moment from 'moment-timezone';
import { CA_HOLIDAYS, US_HOLIDAYS } from './const';
export function getTimeLabel(hour) {
    if (hour === 0)
        return '12 AM';
    if (hour < 12)
        return "".concat(hour, " AM");
    if (hour === 12)
        return '12 PM';
    return "".concat(hour - 12, " PM");
}
export function getCurrentDate() {
    return new Date().toISOString().split('T')[0];
}
/**
 * Calculates timeline value from day, hour, and minutes
 */
export function convertDateTimeToDayIndex(dayOfWeek, hour, minutes) {
    var timelineHour = dayOfWeek * 24 + hour;
    var timelineMinutes = minutes / 60;
    return timelineHour + timelineMinutes;
}
/**
 * Converts timeline value back to day, hour, and minutes
 */
export function convertDayIndexToDateTime(dayIndex) {
    var dayOfWeek = Math.floor(dayIndex / 24);
    var hours = Math.floor(dayIndex % 24);
    var minutes = Math.round((dayIndex % 1) * 60);
    return { dayOfWeek: dayOfWeek, hours: hours, minutes: minutes };
}
export function convertDayIndexToTime(dayIndex) {
    var _a = convertDayIndexToDateTime(dayIndex), hours = _a.hours, minutes = _a.minutes;
    return hours + minutes / 60;
}
export function getTime(dayIndex) {
    var _a = convertDayIndexToDateTime(dayIndex), hours = _a.hours, minutes = _a.minutes;
    // const paddedHours = hours.toString().padStart(2, '0');
    var paddedHoursAMPM = hours % 12 === 0 ? 12 : hours % 12;
    var paddedMinutes = minutes.toString().padStart(2, '0');
    var ampm = hours >= 12 ? 'PM' : 'AM';
    return "".concat(paddedHoursAMPM, ":").concat(paddedMinutes, " ").concat(ampm);
}
export function calculateDateFromDayIndex(dayIndex, selectedDateString, timezone) {
    var hasValidTimezone = Boolean(timezone && moment.tz.zone(timezone));
    var selectedDate = hasValidTimezone
        ? moment.tz(selectedDateString, 'YYYY-MM-DD', timezone).startOf('day')
        : moment(selectedDateString, 'YYYY-MM-DD').startOf('day');
    // Week is Monday-based for the timeline.
    var mondayOfSelectedWeek = selectedDate.clone().isoWeekday(1).startOf('day');
    var daysToAdd = Math.floor(dayIndex / 24);
    var hoursToAdd = dayIndex % 24;
    return mondayOfSelectedWeek
        .clone()
        .add(daysToAdd, 'day')
        .add(hoursToAdd, 'hour')
        .toDate();
}
export function toKebabCase(str) {
    return str
        .replace(/([A-Z])/g, '-$1') // Add hyphen before uppercase letters
        .replace(/[\s_]+/g, '-') // Replace spaces and underscores with hyphens
        .toLowerCase(); // Convert the entire string to lowercase
}
export function generateId() {
    return Date.now().toString(36) + Math.random().toString(36).substr(2);
}
export function decimalToTime(decimalHour) {
    var hours = Math.floor(decimalHour);
    var minutes = Math.round((decimalHour - hours) * 60);
    return { hours: hours, minutes: minutes };
}
export var generateDayTimeOptions = function (config) {
    var _a, _b;
    var options = [];
    var minuteSteps = [0, 15, 30, 45];
    var minMinute = (_a = config.minMinute) !== null && _a !== void 0 ? _a : 0;
    var maxMinute = (_b = config.maxMinute) !== null && _b !== void 0 ? _b : 45;
    var _loop_1 = function (hour) {
        // Para las 12 PM, solo mostrar 12:00, no minutos adicionales
        var isNoon = hour === 12;
        var availableMinutes = isNoon ? [0] : minuteSteps;
        availableMinutes.forEach(function (minute) {
            // Skip if minute is outside the allowed range for this hour
            if (hour === config.minHour && minute < minMinute)
                return;
            if (hour === config.maxHour && minute > maxMinute)
                return;
            if (hour === 24 && minute > 0)
                return;
            var dayIndex = convertDateTimeToDayIndex(parseInt(config.day.value || '', 10), hour, minute);
            var hour12 = hour % 12 === 0 ? 12 : hour % 12;
            var ampm = hour >= 12 && hour < 24 ? 'PM' : 'AM';
            var hourStr = hour12.toString().padStart(2, '0');
            var minuteStr = minute.toString().padStart(2, '0');
            var label = "".concat(config.day.label, " ").concat(hourStr, ":").concat(minuteStr, " ").concat(ampm);
            options.push({ value: dayIndex.toString(), label: label });
        });
    };
    for (var hour = config.minHour; hour <= config.maxHour; hour++) {
        _loop_1(hour);
    }
    return options;
};
// Get the nth occurrence of a specific day of week in a month
// dayOfWeek: 0=Sunday, 1=Monday, etc.
// occurrence: 1=first, 2=second, 3=third, 4=fourth, -1=last
function getNthDayOfWeek(year, month, dayOfWeek, occurrence) {
    if (occurrence === -1) {
        // Last occurrence
        var lastDay = new Date(year, month + 1, 0);
        var lastDayOfWeek = lastDay.getDay();
        var daysToSubtract = (lastDayOfWeek - dayOfWeek + 7) % 7;
        return new Date(year, month, lastDay.getDate() - daysToSubtract);
    }
    // Nth occurrence
    var firstDay = new Date(year, month, 1);
    var firstDayOfWeek = firstDay.getDay();
    var daysToAdd = (dayOfWeek - firstDayOfWeek + 7) % 7;
    var targetDate = 1 + daysToAdd + (occurrence - 1) * 7;
    return new Date(year, month, targetDate);
}
function getGoodFriday(year) {
    // Easter Sunday: first Sunday after the first full moon on or after March 21
    // Uses the Anonymous Gregorian algorithm (Meeus/Jones/Butcher)
    var a = year % 19;
    var b = Math.floor(year / 100);
    var c = year % 100;
    var d = Math.floor(b / 4);
    var e = b % 4;
    var f = Math.floor((b + 8) / 25);
    var g = Math.floor((b - f + 1) / 3);
    var h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4);
    var k = c % 4;
    var l = (32 + 2 * e + 2 * i - h - k) % 7;
    var m = Math.floor((a + 11 * h + 22 * l) / 451);
    var easterMonth = Math.floor((h + l - 7 * m + 114) / 31); // 3=March, 4=April
    var easterDay = ((h + l - 7 * m + 114) % 31) + 1;
    // Good Friday: 2 days before Easter Sunday
    return new Date(year, easterMonth - 1, easterDay - 2);
}
export var getHolidays = function (country, year) {
    if (country === 'US') {
        // Moveable holidays: calculate date based on specific rules
        var moveableHolidays_1 = {
            memorial_day: getNthDayOfWeek(year, 4, 1, -1),
            labor_day: getNthDayOfWeek(year, 8, 1, 1),
            thanksgiving_day: getNthDayOfWeek(year, 10, 4, 4), // Fourth Thursday of November
        };
        return US_HOLIDAYS.map(function (holiday) {
            if (moveableHolidays_1[holiday.value]) {
                var date = moveableHolidays_1[holiday.value];
                return __assign(__assign({}, holiday), { day: date.getDate(), month: date.getMonth() + 1 });
            }
            return __assign({}, holiday);
        });
    }
    if (country === 'CA') {
        var moveableHolidays_2 = {
            ns_heritage_day: getNthDayOfWeek(year, 1, 1, 3),
            good_friday: getGoodFriday(year),
            labour_day: getNthDayOfWeek(year, 8, 1, 1),
            thanksgiving_day: getNthDayOfWeek(year, 9, 1, 2), // Second Monday of October
        };
        return CA_HOLIDAYS.map(function (holiday) {
            if (moveableHolidays_2[holiday.value]) {
                var date = moveableHolidays_2[holiday.value];
                return __assign(__assign({}, holiday), { day: date.getDate(), month: date.getMonth() + 1 });
            }
            return __assign({}, holiday);
        });
    }
    return [];
};
//# sourceMappingURL=utils.js.map